export const handleOTP = (OTP) => {
    if (OTP.toString().length < 6) {
      const zero = 6 - OTP.toString().length;
      for (let i = 0; i < zero; i++) {
        OTP = "0" + OTP;
      }
      return OTP;
    }
    return OTP;
  };